import React from "react"
import {observer} from "mobx-react-lite"
import PoiTable from "./PoiTable"

const PoiTableContainer = () => {
  return <PoiTable />
}
export default observer(PoiTableContainer)
